export default `
# Jockey 外部使用文档

## 安装 Jockey
在 <header> 标签中引入 sdk
    <script src="//assets.souche.com/assets/js/jockey/1.4.18/jockey.js"></script>
## 使用 jockey

### 1. 发送一个事件到 app
    Jockey.send('eventName', payload, callback);

示例：

    // 具体 protocol 协议 data 参数，需要与客户端开发进行沟通
    Jockey.send('moduleHandler', {
        protocol: 'xxx://xxxxx/xxxx,
        data: {
            foo: 'fooo',
            bar: 'barr'
        }
    }, (res) => {
        // res 为客户端返回的内容
    });

### 2. 监听一个来自 App 的事件
    Jockey.on('eventName', callback);

示例：

原生通知 JS 标题栏右侧按钮有点击操作；

    // 注意⚠️：payload 和 complete 是可选参数，使用前需要判断是否存在
    Jockey.on('RightBarEvent', (payload, complete) => {
        // payload 是原生传过来的数据

        // 处理完成后调用 complete()
    })




### 3. 取消监听
    Jockey.off('eventName');

## 事件名 eventName

具体 eventName 的功能和具体参数，使用前请与客户端开发进行沟通

#### Jockey.on/off 可以使用的 eventName
- moreInfoBridge
- moreActionBridge
- shareBridge
- beautyBridge
- shareEventBridge
- shareResultBridge
- refresh
- AppearAction
- DisappearAction
- GoBackEvent
- RightSubBarEvent
- RightBarEvent
<a name="Tj1EQ"></a>
#### Jockey.send 可以使用的 eventName

- moduleHandler
- UserBridge
- getData
- GPSBridge
- JockeyVersionBridge
- CoreBridge
- CapturePicBridge
- CutImageBridge
- BrowsePicBridge
- moduleHandler
- H5MoreBridge
- MapBridge
- AlertBridge
- DownLoadH5Handler
- loadH5
- WechatPaymentBridge
- CarSelectorBridge
- H5ShareBridge
- H5SingleShareBridge
- shareLongImage
- OpenVCBridge
- PopAndPushVCBridge
- PushWebVCBridge
- setRefreshEnable
- TriggleWebVCCallbackBridge
- GetWebVCDataBridge
- SetWebViewTag
- StackManager
- ControlWebVCBridge
- LogoutBridge
- SetWebViewTitle
- SetBottomView
- SetLeftBar
- JockeyExistBridge
- SetCloseBar
- SetRightSubBar
- SetRightBar
`


